let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kB1sA"), load("6Yu8N"), load("cD5e0")]).then(() => parcelRequire('C9t7g'));